module.exports = __webpack_public_path__ + "img/cupgeneric.cd7faeec.svg";